import { action, makeObservable, observable } from 'mobx';

interface UserProfile {
  email: string;
  organization: string;
}

class ProfileStore {
  @observable user: Nullable<UserProfile> = null;

  @action setUser = (data: SimpleObject) => {
    this.user = {
      email: data.email,
      organization: data.organization,
    };
  };

  constructor() {
    makeObservable(this);
  }
}

export default ProfileStore;
